export default {
      id: "patient-usage",
      viewBox: "0 0 38.1 37.8",
      url: __webpack_public_path__ + "img/icons.svg?fe1823f2d070fe6b8364c4176dd9a880#patient",
      toString: function () {
        return this.url;
      }
    }